import React from 'react';
import { Redirect, RedirectProps, useLocation } from 'react-router-dom';

export interface LegacyRedirectProps extends Omit<RedirectProps, 'to'> {
  from: string;
  to: string;
  key?: string;
}

export const RedirectWithQueryParams: React.FC<LegacyRedirectProps> = ({
  from,
  to,
  ...rest
}: LegacyRedirectProps) => {
  const { search } = useLocation();
  return <Redirect key={from} from={from} to={{ pathname: to, search }} {...rest} />;
};
